import SyOverlayContainer from "../../../../shared/components/sy-overlay-container";
import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../services/orbit-service";
import { useDispatch } from "react-redux";
import { setHeader } from "../../../../feature/orbit-slice";
import ProfileDetail from "./profile-details";
import { useGetOrbitDetails } from "../../../../utils/orbitdetails";
import { orbitParamValue } from "../../../../utils/helper";
import { useSearchParams } from "react-router-dom";

type Props = {};

const ProfileScreen = (props: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
  const { profileId } = useParams();
  const [profileData, setProfileData] = useState<any>(null);
  const [openProfileDetails, setOpenProfileDetails] = useState<boolean>(false);
  const { getDetail, isPending, isError } = useGetOrbitDetails();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));

  const onClose = () => {
 
    setOpenProfileDetails(false);
    dispatch(setHeader(true));
    setTimeout(() => {
      navigate(-1);
    }, 500);
  };




  const updateProfileData = (type: any, formValue: any = null) => {
    if (type === "details") {
      getDetail();
      getProfile(profileId);
    } else if (type === "save") {
      updateProfile(formValue);
    }
  };

  const { mutate: getProfile } = useMutation({
    mutationFn: orbitService.getProfile,
    onSuccess(data, variables, context) {
      setProfileData(data.data);
    },
  });

  useEffect(() => {
    getProfile(profileId);
    dispatch(setHeader(false));
    setOpenProfileDetails(true);
  }, [profileId]);

  const { mutate: updateProfile } = useMutation({
    mutationFn: orbitService.updateProfile,
    onSuccess(data, variables, context) {
      getProfile(profileId);
      getDetail();
    },
  });

  return (
  <div className=" h-100" onClick={onClose}>
    <div className="position-absolute bottom-0 px-4  w-100  sy-scroll-y" onClick={(e) => e.stopPropagation()}>
      {profileData && (
        <SyOverlayContainer open={openProfileDetails} height="full">
          <ProfileDetail
            profileData={profileData}
            updateProfileData={updateProfileData}
            onClose={onClose}
          /> 
        </SyOverlayContainer>
      )}
    </div>
    </div>
  );
};

export default ProfileScreen;
